import React from 'react';
import styled from '@benzinga/themetron';
import { CoinInput, CoinList, CoinMarquee } from '@benzinga/crypto';

export interface CryptocurrenciesProps {
  attrs: {
    data: {
      coins: CoinInput[];
      variant: string;
    };
  };
}

export const CryptocurrenciesBlock: React.FC<CryptocurrenciesProps> = ({ attrs }) => {
  const coins = attrs.data?.coins ?? [];
  const variant = attrs.data.variant;
  if (coins.length === 0) return null;
  return (
    <Container className={`cryptocurrencies-block ${variant}`}>
      {attrs.data.variant === 'marquee' ? <CoinMarquee coins={coins} /> : <CoinList coins={coins} />}
    </Container>
  );
};

const Container = styled.div`
  &.cryptocurrencies-block {
    &.marquee {
      height: 118px;
    }

    &.coin-list {
      border-radius: 4px;
      margin-top: 1rem;
      margin-bottom: 1rem;
      padding-bottom: 64px;
      padding-inline-end: 24px;
      padding-inline-start: 24px;
      padding-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .coin-list-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        max-width: 500px;
        width: 100%;
      }
    }
  }
`;
